import {HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest} from "@angular/common/http";
import {catchError, Observable, throwError} from "rxjs";
import {inject} from "@angular/core";
import {AngLiebCoreErrorService} from "@liebink/ang-lieb-core";

export function errorInterceptor(
    req: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
    const errorService = inject(AngLiebCoreErrorService);

    return next(req)
        .pipe(
            catchError((err: HttpErrorResponse) => {
                if (err.status === 401) {
                    errorService.set({code: 'authentication', context: null});
                } else if (err.status === 403) {
                    errorService.set({code: 'authorization', context: null});
                } else if (err.status === 405) {
                    errorService.set({code: 'methodNotAllowed', context: null});
                } else if (err.status === 429) {
                    errorService.set({code: 'tooManyRequests', context: null});
                } else if (err.status >= 500 && err.status <= 599) {
                    errorService.set({code: 'server', context: null});
                }

                return throwError(() => err);
            }),
        );
}